import * as React from 'react';
import { BaseButton, ButtonLook, ButtonProps } from './base_button';

export const ActiveButton = (props: ButtonProps) => (
  <BaseButton look={ButtonLook.ACTIVE} {...props}/>
);
